module.exports = __webpack_public_path__ + "948ba6b5d63b61c2ae6e208d7ece002f.svg";